<template>
  <b-container fluid>
    <b-row class="mx-0">
      <b-col class="px-0">
        <draggable v-model="subTests">
          <transition-group>
            <div
              v-for="(subTest, index) in subTests"
              :key="subTest.id"
              :class="{
                'test': true,

              }"
              @click="$emit('select', subTest)"
            >
              <b-row>
                <b-col cols="1">
                  {{ index + 1 }}
                </b-col>
                <b-col cols="3">
                  {{ subTest.name }}
                </b-col>
                <b-col cols="1">
                  {{ subTest.abbreviation }}
                </b-col>
              </b-row>
            </div>
          </transition-group>
        </draggable>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    name: "SubTest",
    components: {
      draggable
    },
    props: {
      value: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      subTests: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        }
      }
    }
  }
</script>

<style lang="scss"  scoped>
  .test {
    padding: 1rem;
    cursor: pointer;
    text-align: left;
    &:hover {
      background: #dde9ee;
      transition: all 130ms ease-out;
    }

    &.active {
      background: #FB822B;
      color: white;
      transition: all 130ms ease-out;
    }
  }
</style>